#import "../fragments/form-fragment.graphql"

query GetForm($formId: ID, $formSlug: String) {
    form(id: $formId, slug: $formSlug) {
        ...FormFragment
    }
}
